'use strict'

import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false,
            color: {
                r: '51',
                g: '51',
                b: '51',
                a: '0.85',
            },
            value:"rgba(1,2,1,0.5) !important;",
        };
    }

    handleClick() {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose() {
        this.setState({ displayColorPicker: false })
        this.updateStyle(this.state.value,this.props.type);
        this.props.getInput(
            {
                id: this.props.id,
                selector: this.props.selector,
                property: this.props.property,
                value: this.state.value,
                individual: this.props.type
            });
    };

    handleChange(color, event) {
        this.setState({ color: color.rgb })
        this.setState({ value: `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})` })
        this.updateStyle(this.state.value,this.props.type);
    };

    updateStyle(data,type) {
        const head = document.getElementById("akamai-skin-maker");
        const style = document.createElement("style");
        
        style.className = `akamai-temp-override-${type}`;
        style.innerHTML = `.${this.props.selector}{${this.props.property}:${data} !important; } `;
        head.appendChild(style);
    }

    resetStyle(type){
        const head = document.getElementById("akamai-skin-maker");
        const array = Object.assign([], head.getElementsByClassName(`akamai-temp-override-${type}`));
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            element.remove();
        }
    }

    render() {
        const hidden = this.props.data;
        const type = this.props.type;
        let thumbnail = {
            r: '22',
            g: '21',
            b: '21',
            a: '0.1',
        };
        

        if (hidden === type) {
            thumbnail.r = this.state.color.r; 
            thumbnail.g = this.state.color.g; 
            thumbnail.b = this.state.color.b; 
            thumbnail.a = this.state.color.a; 
  
            this.resetStyle(type == 'group' ? 'individual': 'group')
            if('individual' == type)
            {
            this.updateStyle(this.state.value,type)
            }
        }

        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${thumbnail.r}, ${thumbnail.g}, ${thumbnail.b}, ${thumbnail.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div className="option-auto">
                <div style={styles.swatch} onClick={this.handleClick.bind(this)}>
                    <div style={styles.color} />
                </div>
                {this.state.displayColorPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose.bind(this)} />
                    <SketchPicker color={this.state.color} onChange={this.handleChange.bind(this)} />
                </div> : null}

            </div>
        )
    }
}

export default ColorPicker